import React, { lazy } from 'react';
import { Route, IndexRoute } from 'react-router';
import ProgressContainer from 'chameleon-src/components/progress/ProgressContainer';
import ValidatedRoute from 'chameleon-src/utility/validatedRoute';
import scoreByRubric from './ScoreByRubrics';

const Assignment = lazy(
  () => import('legacy-src/components/assignment/Assignment'),
);
const ProctoringWrapper = lazy(
  () => import('legacy-src/components/ProctoringReportWrapper'),
);

const assignmentIndex = <IndexRoute component={Assignment} leftNav={false} />;
const assignmentPreview = (
  <Route
    name="assignmentPreview"
    path="preview"
    component={Assignment}
    leftNav={false}
  />
);
const submissionView = (
  <Route
    name="submissionView"
    path="student/:studentId"
    component={Assignment}
    leftNav={false}
  />
);
const proctoringWrapper = (
  <Route
    name="proctoringWrapper"
    path="live_status"
    component={ProctoringWrapper}
    leftNav={false}
  />
);

const routes = (
  <Route
    name="progress"
    path="progress"
    component={ValidatedRoute(ProgressContainer)}
    leftNav
  >
    <Route name="assignment-progress" path=":assignmentId" leftNav={false}>
      {assignmentIndex}
      {assignmentPreview}
      {submissionView}
      {proctoringWrapper}
    </Route>

    {scoreByRubric}
  </Route>
);

export default routes;
